import Pagination from './base/pagination';
import Loading from './base/loading';
import BreadCrumb from './base/bread-crumb';
import Modal from './base/modal';
import IconSelect from './base/iconselect';
import TreeSelect from './base/treeselect.vue';
import TreeJurisdiction from './base/treejurisdiction.vue';
import UploadImg from './base/upload-img.vue';
import ModifyModal from './base/modify-modal';
import Topbar from './base/topbar.vue';

export default function(Vue){
  Vue.component('pagination', Pagination);
  Vue.component('loading', Loading);
  Vue.component('bread-crumb', BreadCrumb);
  Vue.component('modal', Modal);
  Vue.component('iconselect', IconSelect);
  Vue.component('treeselect',TreeSelect);
  Vue.component('treejurisdiction',TreeJurisdiction);
  Vue.component('upload-img',UploadImg);
  Vue.component('modify-modal', ModifyModal);
  Vue.component('topbar', Topbar);
}



// WEBPACK FOOTER //
// ./src/components/registerComponent.js